import React from 'react'
import '../stylings/newsMarquee.css'
import Marquee from 'react-fast-marquee'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const NewsMarquee = () => {
    const { notices } = useSelector((state) => state.notices)

    return (
        <div className="news-marquee-wrapper sticky-top1">
            <div className="marquee-label">
                <i className="fa-solid fa-bullhorn"></i>
                Latest News
            </div>
            <Marquee pauseOnHover={true} gradient={false} speed={45}>
                <span className="marquee-text">
                    {notices.map((notice, index) => index < 5 && (
                        <span key={notice.id} style={{ marginRight: '4rem' }}>
                            <i className="fa-solid fa-circle" style={{ fontSize: '0.4rem', verticalAlign: 'middle', marginRight: '0.5rem', color: 'rgba(245,166,35,0.7)' }}></i>
                            <Link to={`/notice/${notice.id}`}>{notice.subject}</Link>
                        </span>
                    ))}
                </span>
            </Marquee>
        </div>
    )
}

export default NewsMarquee
